module.exports = __webpack_public_path__ + "static/media/stock-wedding-glasses.265db1c6.jpg";